import React from 'react';
import { useForm } from 'react-hook-form';

import Field from 'components/Field';
import Button from 'components/Button';

const Profile = ({user, onSubmit}) => {
  const { handleSubmit, register, formState: { errors } } = useForm({defaultValues: user});
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Field label="Email" type="text"
        disabled
        register={
          register("email", {
            required: true,
          })
        } />
      <Field label="Nom" type="text"
        name="last_name"
        register={
          register("last_name", {
            required: true,
          })
        } />
      <Field label="Prénoms" type="text"
        register={
          register("first_name", {
            required: true,
          })
        } />
      <Field label="Téléphone" type="text"
      register={
        register("phone")
        } />
      <Field label="Date de naissance" type="date"
        register={
        register("birth_date")
        } />
      <div className="">
        <Button type="submit" className="is-primary">
          Modifier
        </Button>
      </div>
    </form>
  );
}

export default Profile;